/**
 * Created by Jerker Nord on 2020-08-04.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {MonkeysGoldGameConfig} from "../MonkeysGoldGameConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {MonkeysGoldParsedInitData} from "../server/data/MonkeysGoldParsedInitData";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {MonkeysGoldGameAssets} from "../MonkeysGoldGameAssets";

export class MonkeysGoldLogo extends BaseView {

    public static monkeysGoldLogo:MonkeysGoldLogo;

    private _layer:ScalableLayer;
    private _mainGameLogoContainer:PIXI.Container;
    private _mainGameLogoImage:PIXI.Sprite;
    private _bonusGameLogoContainer:PIXI.Container;
    private _bonusGameLogoImage:PIXI.Sprite;
    private _landscapePosition:PIXI.Point = new PIXI.Point(-110, 107);//+37
    private _portraitPosition:PIXI.Point = new PIXI.Point(360, 20);
    private static PORTRAIT_HIDDEN_LOGO_STAGE_Y_POS:number = -70;

    constructor() {
        super();
        this._mainGameLogoContainer = new PIXI.Container();
        this._bonusGameLogoContainer = new PIXI.Container();
        this._layer = StageManager.getLayer(MonkeysGoldGameConfig.instance.LAYERS.LOGO.name);
        MonkeysGoldLogo.monkeysGoldLogo = this;
        this.addFeatureEventHandlers();
    }

    private addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    private onInitDataParsed(data:MonkeysGoldParsedInitData):void {
        if(data.mode == GameMode.FREESPIN_AVALANCHE || data.mode == GameMode.FREESPIN) {
            this.enableBonusGameLogo();
        } else {
            this.enableMainGameLogo();
        }
    }

    protected initAnimations():void {
        this._layer.addChild(this);

        this.addChild(this._mainGameLogoContainer);
        this._mainGameLogoImage = new PIXI.Sprite(GameResources.getTextures(MonkeysGoldGameAssets.INTRO_LOGO)[0]);
        this._mainGameLogoImage.anchor.set(0.5, 0.5);
        this._mainGameLogoImage.position.y = -10;
        this._mainGameLogoImage.scale.set(228 / 205, 228 / 205);
        this._mainGameLogoContainer.addChild(this._mainGameLogoImage);

        this.addChild(this._bonusGameLogoContainer);
        this._bonusGameLogoImage = new PIXI.Sprite(GameResources.getTextures("bonusGameLogo")[0]);
        this._bonusGameLogoImage.anchor.set(0.5, 0.5);
        this._bonusGameLogoImage.position.y = -10;
        this._bonusGameLogoContainer.addChild(this._bonusGameLogoImage);
    }

    protected onResize(resizeData:IResizeData):void {
        if(this._resizeData.orientation == Orientation.LANDSCAPE) {
            StageManager.stage.position.y = 0;
            //Calculate logo space to the left
            const leftSpace:number = (resizeData.width - 720) / 2;
            this._mainGameLogoImage.scale.set(0.84, 0.84);
            this._bonusGameLogoImage.scale.set(0.84, 0.84);
            if((leftSpace - 28) > this._mainGameLogoImage.width) {
                this._mainGameLogoImage.visible = true;
                this._bonusGameLogoImage.visible = true;
                this._mainGameLogoContainer.position = this._landscapePosition;
                this._bonusGameLogoContainer.position = this._landscapePosition;
            } else {
                this._mainGameLogoImage.visible = false;
                this._bonusGameLogoImage.visible = false;
            }
        } else {
            //Calculate logo top space
            const topSpace:number = (resizeData.height - 720) / 2;
            this._mainGameLogoImage.scale.set(0.84, 0.84);
            this._bonusGameLogoImage.scale.set(0.84, 0.84);
            if((topSpace + 30) > this._mainGameLogoImage.height) {
                this._mainGameLogoImage.visible = true;
                this._bonusGameLogoImage.visible = true;
                this._mainGameLogoContainer.position = this._portraitPosition;
                this._bonusGameLogoContainer.position = this._portraitPosition;
                StageManager.stage.position.y = 0;
            } else {
                this._mainGameLogoImage.visible = false;
                this._bonusGameLogoImage.visible = false;
                StageManager.stage.position.y = MonkeysGoldLogo.PORTRAIT_HIDDEN_LOGO_STAGE_Y_POS;
            }
        }
    }

    public enableMainGameLogo():void {
        this._mainGameLogoContainer.visible = true;
        this._bonusGameLogoContainer.visible = false;
    }

    public enableBonusGameLogo():void {
        this._mainGameLogoContainer.visible = false;
        this._bonusGameLogoContainer.visible = true;
    }
}